// extracted by mini-css-extract-plugin
export default {"amazonBooksCarouselContainer":"AmazonBooksCarousel_amazonBooksCarouselContainer__uvab6"};